import React, { useEffect } from 'react';
import { BaseSpin, BaseTabs } from '@components';
import { TEST_IDS } from '@constants/testIds.ts';
import { useAppDispatch, useAppSelector } from '@hooks/reduxHooks.ts';
import { useLingui } from '@lingui/react/macro';
import { SharedPageWrapper } from '@routes/___shared___/styled.tsx';
import { PageHeader, PageHeaderWrapper } from '@routes/profile-bar/___pages___/my-profile/styled.tsx';
import { clearImportedLearningsState } from '@routes/profile-bar/___pages___/my-results/model/importedLearnings.slice.ts';
import { clearResultsState } from '@routes/profile-bar/___pages___/my-results/model/results.slice.ts';
import ProfileHeader from '@routes/sidebar/___shared___/components/profile-header';
import type { TabsProps } from 'antd';

import MyAssessmentTab from './ui/MyAssessmentTab.tsx';
import MyImportedLearningsTab from './ui/MyImportedLearningsTab.tsx';
import MyLearningTab from './ui/MyLearningTab.tsx';

const useTabs = (): TabsProps['items'] => {
    const { t } = useLingui();

    return [
        {
            key: 'my-learning',
            label: <span data-cy={TEST_IDS.PROFILE.TAB_MY_LEARNING}>{t`My learning`}</span>,
            children: <MyLearningTab />,
        },
        {
            key: 'my-assessment',
            label: <span data-cy={TEST_IDS.PROFILE.TAB_MY_ASSESSMENT}>{t`My assessment`}</span>,
            children: <MyAssessmentTab />,
        },
        {
            key: 'my-imported-learnings',
            label: <span data-cy={TEST_IDS.PROFILE.TAB_MY_IMPORTED_LEARNINGS}>{t`My Imported Learnings`}</span>,
            // TODO: Replace with the real data when backend is ready
            children: <MyImportedLearningsTab />,
        },
    ];
};

const MyResults: React.FC = () => {
    const { t } = useLingui();
    const dispatch = useAppDispatch();
    const isGetFullUserInfoPending = useAppSelector((state) => state.user.isGetFullUserInfoPending);
    const tabs = useTabs();

    useEffect(() => {
        return () => {
            dispatch(clearResultsState());
            dispatch(clearImportedLearningsState());
        };
    }, [dispatch]);

    if (isGetFullUserInfoPending) {
        return <BaseSpin size="large" />;
    }

    return (
        <SharedPageWrapper>
            <PageHeaderWrapper>
                <PageHeader>{t`Results`}</PageHeader>
            </PageHeaderWrapper>
            <ProfileHeader />
            <BaseTabs defaultActiveKey="my-learning" items={tabs} />
        </SharedPageWrapper>
    );
};

export default MyResults;
